import React, { Component } from 'react'
import { Input } from 'antd'

const HEART_BEAT = 10;

class Stopwatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timerOn: false,
      timerStart: 0,
      timerTime: 0
    };
  }

  startTimer = () => {
    this.setState({
      timerOn: true,
      timerTime: this.state.timerTime,
      timerStart: Date.now() - this.state.timerTime
    });
    this.timer = setInterval(() => {
      this.setState({
        timerTime: Date.now() - this.state.timerStart
      });
    }, HEART_BEAT);
  };

  resumeTimer = () => {
    if (this.timer === undefined) {
      return;
    }

    this.startTimer(null);
  };

  stopTimer = () => {
    clearInterval(this.timer);
    this.setState({ timerOn: false });
  };

  resetTimer = () => {
    this.setState({
      timerStart: 0,
      timerTime: 0
    });
  };

  copyText = () => {
    this.refs.input.select();
    document.execCommand('copy');
  };

  goTestLink = (link) => {
    window.open(link, '_blank')
  };

  // Do some clean up before unmounting.
  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  render() {

    const { timerTime, timerOn } = this.state;
    const { link } = this.props;
    // let centiseconds = ("0" + (Math.floor(timerTime / 10) % 100)).slice(-2);
    let seconds = ("0" + (Math.floor(timerTime / 1000) % 60)).slice(-2);
    let minutes = ("0" + (Math.floor(timerTime / 60000) % 60)).slice(-2);
    // let hours = ("0" + Math.floor(timerTime / 3600000)).slice(-2);
    const value = `${minutes} : ${seconds}`
    const startText = 'Start Test';
    const stopIcon = <i className="axiom-icon-icon icon-pause" onClick={this.stopTimer}/>;
    const resetIcon = <i className="axiom-icon-icon icon-refresh-cw" onClick={this.resetTimer}/>;
    const playIcon = <i className="axiom-icon-icon icon-play" onClick={this.resumeTimer}/>;
    const addonBeforeIcon = timerOn? stopIcon: playIcon;

    return (
      <div className="stopwatch">
        <Input 
          ref="input"
          size="large" 
          addonBefore={addonBeforeIcon} 
          addonAfter={resetIcon} 
          value={value} 
          style={{width: '150px'}}
          onClick={this.copyText}
          readOnly
        />
        <button 
          onClick={() => {
            this.startTimer();
            this.goTestLink(link);
          }}
          className="axiom-button-button axiom-button-icon-left"
        >
          <i className="axiom-icon-icon icon-link"/>
          {startText}
        </button>
      </div>
    )
  }

}

export default Stopwatch